import { useMutation } from '@tanstack/react-query';
import { uploadTaskFile } from '@/api/tasks/uploadTaskFile';
import { toast } from 'react-toastify';
import { useI18n } from '@/features/i18n/useI18n';

const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

export const useUploadTaskFile = () => {
  const { t } = useI18n();

  return useMutation({
    mutationFn: ({ file, taskId }: { file: File; taskId: string }) => {
      // Validar tamaño del archivo
      if (file.size > MAX_FILE_SIZE) {
        throw new Error('File size exceeds 10MB limit');
      }

      // Construir FormData
      const formData = new FormData();
      formData.append('file', file);
      formData.append('taskId', taskId);

      return uploadTaskFile(formData);
    },
    onSuccess: () => {
      toast.success(t('tasks.fileUploadSuccess'));
    },
    onError: (error: Error) => {
      toast.error(error.message || t('tasks.fileUploadError'));
    },
  });
}; 